import I18n from 'i18n-js';
import SessionStorageConst from '../consts/SessionStorageConst';
import { Language } from './Language';
import en from './resources/en';
import hr from './resources/hr';

let currentLanguage = sessionStorage.getItem(SessionStorageConst.Language) as Language;

if (!currentLanguage) {
    currentLanguage = 'hr';
    sessionStorage.setItem(SessionStorageConst.Language, currentLanguage);
}

const availableTranslations = {
    hr,
    en,
    'hr-HR': hr,
    'hr-US': hr,
    'en-HR': en,
    'en-US': en,
    'en-GB': en,
};

I18n.fallbacks = true;
I18n.translations = availableTranslations;
I18n.locale = currentLanguage;
I18n.defaultLocale = currentLanguage;

I18n.pluralization['hr'] = function (n: any) {
    const key = n % 10 === 1 && n % 100 !== 11 ? 'one' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'few' : 'other';
    return [key];
};

export default I18n;
